<template>
  <ReactPage>
    <locality-config-page></locality-config-page>
  </ReactPage>
</template>

<script>
import ReactPage from "../components/ReactPage.vue";

export default {
  name: "LocalityConfig",
  components: {
    ReactPage,
  },
};
</script>
